document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  // 1. Fonctions pour Ouvrir / Fermer
  window.openCartDrawer = () => {
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };

  window.closeCartDrawer = () => {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  // 2. Écouteurs pour fermer le tiroir (Croix ou clic dans le vide)
  drawer.addEventListener('click', (e) => {
    if (e.target.matches('.cart-drawer__overlay, .cart-drawer__close, .cart-drawer__close *')) {
      window.closeCartDrawer();
    }
  });

  // 3. Intercepter le bouton "Ajouter au panier"
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (form) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const submitBtn = form.querySelector('[type="submit"], button:not([type="button"])');
      if (submitBtn) submitBtn.disabled = true;

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(() => {
        updateCartDrawer();
        window.openCartDrawer();
      })
      .catch((error) => console.error('Erreur lors de l\'ajout au panier:', error))
      .finally(() => {
        if (submitBtn) submitBtn.disabled = false;
      });
    }
  }, true);

  // 4. Mettre à jour les quantités (+ / -) dans le tiroir en AJAX
  drawer.addEventListener('click', (e) => {
    const btn = e.target.closest('.cart-ajax-btn');
    if (btn) {
      e.preventDefault();
      
      const url = new URL(btn.href, window.location.origin);
      const line = url.searchParams.get('line');
      const quantity = url.searchParams.get('quantity');

      drawer.querySelector('.cart-drawer__content').style.opacity = '0.5';

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
      .then(() => {
        updateCartDrawer();
      });
    }
  });

  // 5. Rafraîchir le contenu du tiroir
  function updateCartDrawer() {
    fetch('/?section_id=cart-drawer')
      .then(response => response.text())
      .then(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        
        const newContent = tempDiv.querySelector('#CartDrawerContent');
        if (newContent) {
          document.getElementById('CartDrawerContent').innerHTML = newContent.innerHTML;
        }
        
        drawer.querySelector('.cart-drawer__content').style.opacity = '1';
      });
  }

  // 6. Intercepter les clics sur l'icône du panier (Header)
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href*="/cart"]');
    if (!link) return;

    // On ignore les liens du drawer (Voir le panier, Valider, +/-)
    if (link.closest('#CartDrawer')) return;

    // On ignore les liens de la page panier classique (/cart/change, /cart/remove)
    const href = link.getAttribute('href');
    if (href.includes('/cart/change') || href.includes('/cart/remove')) return;

    // Tout le reste (icône panier header, etc.) → ouvre le drawer
    e.preventDefault();
    updateCartDrawer();
    window.openCartDrawer();
  });

  // 7. Forcer la redirection vers le paiement
  document.addEventListener('click', (e) => {
    const checkoutBtn = e.target.closest('button[name="checkout"], input[name="checkout"], .cart-submit');
    
    if (checkoutBtn && e.target.closest('#CartDrawer')) {
      e.preventDefault();
      window.location.href = '/checkout';
    }
  });

});